var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spnod-admin__form--container container mx-0 w-100 h-100",
    class: _vm.isMobile ? 'px-0' : 'px-3'
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments)
      }
    }
  }, [_c('b-form-group', {
    staticClass: "mb-4"
  }, [_c('b-form-input', {
    staticClass: "mb-2",
    attrs: {
      "name": "username",
      "state": _vm.validateState('username'),
      "type": "text",
      "placeholder": "Email",
      "size": "sm"
    },
    model: {
      value: (_vm.$v.form.username.$model),
      callback: function($$v) {
        _vm.$set(_vm.$v.form.username, "$model", $$v)
      },
      expression: "$v.form.username.$model"
    }
  }), _vm._v(" "), _c('b-input-group', {
    staticClass: "mb-2"
  }, [_c('b-form-input', {
    staticClass: "mb-0",
    attrs: {
      "name": "password",
      "state": _vm.validateState('password'),
      "type": _vm.isPasswordDisplayed,
      "placeholder": "Password",
      "size": "sm"
    },
    model: {
      value: (_vm.$v.form.password.$model),
      callback: function($$v) {
        _vm.$set(_vm.$v.form.password, "$model", $$v)
      },
      expression: "$v.form.password.$model"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('span', {
    staticClass: "input-group-text small spnod-cursor",
    on: {
      "click": function($event) {
        return _vm.handlePassToggle('password')
      }
    }
  }, [(!_vm.showPassword) ? _c('i', {
    staticClass: "fa fa-eye fa-sm"
  }) : _c('i', {
    staticClass: "fa fa-eye-slash fa-sm"
  })])])], 1), _vm._v(" "), _c('ul', {
    staticClass: "spnod-admin__form--list"
  }, [_c('li', [_c('router-link', {
    staticClass: "spnod-admin__form--link",
    attrs: {
      "id": "signup",
      "to": "/signup"
    }
  }, [_vm._v("Sign Up")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "spnod-admin__form--link",
    attrs: {
      "id": "forgot-password",
      "to": "/forgot-password"
    }
  }, [_vm._v("Forgot Password")])], 1)])], 1), _vm._v(" "), _c('b-form-group', {
    staticClass: "d-flex justify-content-end"
  }, [_c('b-button', {
    staticClass: "spnod-admin__form--button",
    attrs: {
      "type": "submit",
      "size": "sm",
      "disabled": _vm.isDisabled
    }
  }, [(!_vm.isSending) ? _c('p', [_vm._v("Login")]) : _c('span', {
    staticClass: "spinner-border spinner-border-sm",
    attrs: {
      "role": "status",
      "aria-hidden": "true"
    }
  })])], 1)], 1), _vm._v(" "), _vm._m(0)], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex align-items-center flex-column"
  }, [_c('a', {
    staticClass: "spnod-admin__form--link mb-1 text-muted",
    attrs: {
      "href": "https://app.termly.io/document/terms-of-use-for-website/6a339b70-c0f6-46e7-ae47-1bb78046b8b9",
      "target": "_blank"
    }
  }, [_vm._v("\n      Terms of Service\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "spnod-admin__form--link text-muted",
    attrs: {
      "href": "mailto:support@spnod.com"
    }
  }, [_vm._v("\n      Contact us\n    ")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16c2a5f1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/Forms/LoginForm.vue
// module id = +vgg
// module chunks = 2